export default __webpack_public_path__ + "static/media/mochi.ca78ba60.jpg";